import React, { useRef, useState, useEffect } from "react";

import { ROUTE_VIEWS } from "../constants/constants";
import useZendesk from "../hooks/useZendesk";
import DayUseWrapper from "../views/children/DayUsePage/DayUseWrapper";
import ActivitiesSelectionsView from "../views/children/DayUsePage/Views/ActivitiesSelectionsView";
import WindowWidth from "../hooks/WindowWidth";
import RegistrationView from "../views/children/DayUsePage/Views/RegistrationView";
import RegistrationViewAddCardView from "../views/children/DayUsePage/Views/RegistrationViewAddCardView";
import RegistrationViewPreConfirmView from "../views/children/DayUsePage/Views/RegistrationViewPreConfirmView";
import ConfirmationScreenView from "../views/children/DayUsePage/Views/ConfirmationScreenView";
import BasketDetailsView from "../views/children/DayUsePage/Views/BasketDetailsView";
import LocationsDetailsView from "../views/children/DayUsePage/Views/LocationsDetailsView";
import LocationDetailsView from "../views/children/DayUsePage/Views/LocationDetailsView";
import BookedDayUseView from "../views/children/DayUsePage/Views/BookedDayUseView";

const RouteLogic = () => {
  const { width } = WindowWidth();
  const isDesktop = width >= 1024;
  const scrollRef = useRef(null);

  const [view, setView] = useState({
    type: window.location.pathname.includes("/day-use-view")
      ? ROUTE_VIEWS.DAY_USE_MY_BOOKINGS_VIEW
      : ROUTE_VIEWS.DAY_USE_INITIAL_VIEW,
    pageDetails: {},
  });
  const [manualDropdownOpen, setManualDropdownOpen] = useState(false);
  const [isScrollingStarted, setIsScrollingStarted] = useState(false);
  useZendesk(view);

  const checkIfScrolledToTop = () => {
    if (scrollRef.current.scrollTop === 0) {
      setIsScrollingStarted(false);
      setManualDropdownOpen(true);
    }
  };

  useEffect(() => {
    if (isScrollingStarted) {
      scrollRef?.current?.addEventListener("scroll", checkIfScrolledToTop);
    }

    return () => {
      scrollRef?.current?.removeEventListener("scroll", checkIfScrolledToTop);
    };
  }, [isScrollingStarted]);

  const scrollToTop = () => {
    if (!isDesktop) {
      setIsScrollingStarted(true);
      scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setManualDropdownOpen(true);
    }
  };

  const appScreens = {
    [ROUTE_VIEWS.DAY_USE_INITIAL_VIEW]: (
      <ActivitiesSelectionsView
        scrollToTop={scrollToTop}
        isDesktop={isDesktop}
      />
    ),
    [ROUTE_VIEWS.DAY_USE_REG_FORM_VIEW]: (
      <RegistrationView isDesktop={isDesktop} />
    ),
    [ROUTE_VIEWS.DAY_USE_REG_VIEW_ADD_CARD_VIEW]: (
      <RegistrationViewAddCardView />
    ),
    [ROUTE_VIEWS.DAY_USE_REG_VIEW_PRECONFIRM_VIEW]: (
      <RegistrationViewPreConfirmView isDesktop={isDesktop} />
    ),
    [ROUTE_VIEWS.DAY_USE_CONFIRMATION_VIEW]: (
      <ConfirmationScreenView />
    ),
    [ROUTE_VIEWS.DAY_USE_BASKET_DETAILS_VIEW]: (
      <BasketDetailsView isDesktop={isDesktop} />
    ),
    [ROUTE_VIEWS.DAY_USE_HOTELS_VIEW]: (
      <LocationsDetailsView
        isDesktop={isDesktop}
        manualDropdownOpen={manualDropdownOpen}
        setManualDropdownOpen={setManualDropdownOpen}
      />
    ),
    [ROUTE_VIEWS.DAY_USE_SINGLE_HOTEL_VIEW]: (
      <LocationDetailsView
        isDesktop={isDesktop}
        setManualDropdownOpen={setManualDropdownOpen}
        manualDropdownOpen={manualDropdownOpen}
      />
    ),
    [ROUTE_VIEWS.DAY_USE_MY_BOOKINGS_VIEW]: (
      <BookedDayUseView />
    ),
  };

  const switchPages = (chosenView) => {
    const selectedRoute = appScreens[chosenView.type];

    if (!selectedRoute) {
      console.info("Unknow view " + view);
      return;
    }

    return (
      <DayUseWrapper
        scrollRef={scrollRef}
        manualDropdownOpen={manualDropdownOpen}
        setManualDropdownOpen={setManualDropdownOpen}
      >
        {selectedRoute}
      </DayUseWrapper>
    );
  };

  return {
    view,
    manualDropdownOpen,
    setManualDropdownOpen,
    setView,
    switchPages,
  };
};

export default RouteLogic;
